/* ZAKDOR - the sign-in invitation.

   A shopper who has been on the site for half a minute or more is shown,
   once, the same two ways in that the account page offers: Google, or an
   email code. Both land on Shopify's own login page, which is where the
   Google button really lives - nothing about sign-in is handled here.

   It stays out of the way: never for a signed-in customer, never while
   the order popup is open, never twice in a session, and not again for
   three days once dismissed. The theme sets window.__zkAuth with the
   login URL and whether a customer is signed in. */
(function () {
  if (window.__axAuth) return;
  window.__axAuth = 1;

  var CFG = window.__zkAuth || {};
  var LOGIN = CFG.login || '/account/login';
  var LOGO = 'https://cdn.shopify.com/s/files/1/0832/7387/5715/files/real_zakdor_inverse_logo_7b938d75-f756-4351-ac0f-158fa1cd225a.png'
    + '?v=1788098101&width=760&height=230&crop=center';

  var MIN = 30000, MAX = 45000;                 // the window the popup opens in
  var SNOOZE = 3 * 24 * 60 * 60 * 1000;         // after "maybe later"
  var DONE = 30 * 24 * 60 * 60 * 1000;          // after tapping a sign-in button

  if (CFG.loggedIn) return;
  var path = window.location.pathname || '';
  if (/\/checkouts?\b|\/account|\/customer_authentication|\/apps\/track|\/challenge|\/password/.test(path)) return;

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, String(v)); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function session(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, String(v)); } catch (e) { return null; } }

  var until = Number(load('zk_auth_until') || 0);
  if (until && Date.now() < until) return;
  if (session('zk_auth_shown')) return;

  var CSS = ''
  + '.zka{position:fixed;inset:0;z-index:2147483003;display:grid;place-items:center;padding:18px;'
  +   'background:rgba(5,11,24,.62);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);'
  +   'opacity:0;transition:opacity .28s ease}'
  + '.zka.on{opacity:1}'
  + '.zka-c{position:relative;width:100%;max-width:400px;background:#fff;color:#0A1730;border-radius:22px;overflow:hidden;'
  +   'box-shadow:0 40px 90px rgba(2,6,16,.5);transform:translateY(22px) scale(.98);opacity:0;'
  +   'transition:transform .42s cubic-bezier(.16,1,.3,1),opacity .3s ease;font-family:inherit}'
  + '.zka.on .zka-c{transform:none;opacity:1}'
  + '.zka-c *{box-sizing:border-box}'
  + '.zka-hd{position:relative;padding:26px 24px 22px;background:radial-gradient(120% 120% at 15% 0%,#1E4494 0%,#0A1730 60%,#060E20 100%);color:#fff;text-align:center}'
  + '.zka-hd img{height:34px;width:auto;max-width:200px;object-fit:contain;display:block;margin:0 auto 14px}'
  + '.zka-wm{display:block;font-size:17px;font-weight:800;letter-spacing:.08em;margin:0 0 14px}'
  + '.zka-hd b{display:block;font-size:19px;font-weight:700;letter-spacing:-.01em;line-height:1.25;text-wrap:balance}'
  + '.zka-hd p{margin:8px auto 0;font-size:13px;line-height:1.55;color:#A6B6D1;max-width:30ch}'
  + '.zka-x{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:9px;border:1px solid rgba(255,255,255,.14);'
  +   'background:rgba(255,255,255,.06);color:#C7D3E8;cursor:pointer;display:grid;place-items:center;padding:0;font-family:inherit;transition:background .15s,color .15s}'
  + '.zka-x:hover{background:rgba(255,255,255,.14);color:#fff}'
  + '.zka-x svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2.2;stroke-linecap:round}'
  + '.zka-b{padding:20px 22px 8px;display:grid;gap:10px}'
  + '.zka-btn{display:flex;align-items:center;justify-content:center;gap:11px;width:100%;padding:13px 16px;border-radius:12px;'
  +   'font:inherit;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;transition:transform .15s,box-shadow .2s,background .15s,border-color .15s;position:relative}'
  + '.zka-btn:hover{transform:translateY(-1px)}'
  + '.zka-btn svg{width:19px;height:19px;flex:0 0 auto}'
  + '.zka-g{background:#fff;color:#0A1730;border:1px solid #D9DFEA;box-shadow:0 1px 2px rgba(10,23,48,.06)}'
  + '.zka-g:hover{border-color:#B7C3D8;box-shadow:0 8px 20px rgba(10,23,48,.12)}'
  + '.zka-e{background:linear-gradient(135deg,#1E4494 0%,#0A1730 78%);color:#fff;border:0}'
  + '.zka-e:hover{box-shadow:0 10px 24px rgba(30,68,148,.35)}'
  + '.zka-e svg{stroke:currentColor;fill:none;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}'
  + '.zka-or{display:flex;align-items:center;gap:10px;font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#A6AEBD;margin:2px 0}'
  + '.zka-or:before,.zka-or:after{content:"";flex:1;height:1px;background:#EAEEF5}'
  + '.zka-perks{display:flex;justify-content:space-between;gap:8px;list-style:none;margin:14px 0 0;padding:14px 4px 0;border-top:1px solid #EEF1F6}'
  + '.zka-perks li{flex:1;text-align:center;font-size:10.5px;font-weight:600;color:#8A94A6;line-height:1.35}'
  + '.zka-perks svg{display:block;width:18px;height:18px;margin:0 auto 5px;stroke:#2C5CC5;fill:none;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}'
  + '.zka-ft{padding:6px 22px 20px;text-align:center}'
  + '.zka-later{background:none;border:0;padding:8px 10px;font:inherit;font-size:13px;font-weight:600;color:#5A6779;cursor:pointer;border-radius:8px}'
  + '.zka-later:hover{color:#0A1730;background:#F1F4F9}'
  + '.zka-law{margin:2px 0 0;font-size:10.5px;color:#A6AEBD;line-height:1.5}'
  + '.zka-law a{color:#8A94A6}'
  + '@media(max-width:520px){'
  +   '.zka{padding:0;align-items:end}'
  +   '.zka-c{max-width:none;border-radius:22px 22px 0 0;transform:translateY(40px)}'
  +   '.zka-ft{padding-bottom:calc(18px + env(safe-area-inset-bottom))}'
  + '}'
  + '@media(prefers-reduced-motion:reduce){.zka,.zka-c,.zka-btn{transition:none}}';

  function ico(paths) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + paths + '</svg>'; }
  function google() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">'
      + '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.57c2.08-1.92 3.27-4.74 3.27-8.09z"/>'
      + '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.76c-.98.66-2.23 1.05-3.71 1.05-2.86 0-5.28-1.93-6.15-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>'
      + '<path fill="#FBBC05" d="M5.85 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.43.35-2.1V7.06H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.94l3.67-2.84z"/>'
      + '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 12 1 11 11 0 0 0 2.18 7.06L5.85 9.9C6.72 7.31 9.14 5.38 12 5.38z"/></svg>';
  }

  function withReturn(url) {
    var back = window.location.pathname + window.location.search;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'return_to=' + encodeURIComponent(back) + '&return_url=' + encodeURIComponent(back);
  }

  var box = null, lastFocus = null;

  function html() {
    var go = withReturn(LOGIN);
    return '<div class="zka-c" role="dialog" aria-modal="true" aria-labelledby="zkaT">'
      + '<div class="zka-hd">'
      + '<button type="button" class="zka-x" data-zka-close aria-label="Close">' + ico('<path d="M18 6L6 18M6 6l12 12"/>') + '</button>'
      + '<img src="' + LOGO + '" alt="Zakdor">'
      + '<b id="zkaT">Sign in for faster delivery</b>'
      + '<p>Your orders, tracking and offers, all in one place - no forms to fill next time.</p>'
      + '</div>'
      + '<div class="zka-b">'
      + '<a class="zka-btn zka-g" href="' + go + '" data-zka-go>' + google() + 'Continue with Google</a>'
      + '<div class="zka-or">or</div>'
      + '<a class="zka-btn zka-e" href="' + go + '" data-zka-go>'
      +   ico('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M3 8l9 6 9-6"/>') + 'Continue with email</a>'
      + '<ul class="zka-perks">'
      + '<li>' + ico('<rect x="1.5" y="6" width="13" height="10" rx="1.5"/><path d="M14.5 9h4l3 3.5V16h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/>') + 'Track every order</li>'
      + '<li>' + ico('<path d="M13 2L4 14h6l-1 8 9-12h-6z"/>') + 'Faster checkout</li>'
      + '<li>' + ico('<rect x="3" y="8" width="18" height="12" rx="2"/><path d="M12 8v12M3 12h18"/><path d="M12 8S9.6 3.4 7.7 4.5 9.6 8 12 8zM12 8s2.4-4.6 4.3-3.5S14.4 8 12 8z"/>') + 'Member offers</li>'
      + '</ul></div>'
      + '<div class="zka-ft">'
      + '<button type="button" class="zka-later" data-zka-close>Maybe later</button>'
      + '<p class="zka-law">By continuing you agree to our <a href="/policies/terms-of-service">Terms</a> and <a href="/policies/privacy-policy">Privacy Policy</a>.</p>'
      + '</div></div>';
  }

  function close(snooze) {
    if (!box) return;
    box.classList.remove('on');
    if (snooze) store('zk_auth_until', Date.now() + SNOOZE);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    var b = box; box = null;
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function open() {
    if (box) return;
    var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);
    box = document.createElement('div');
    box.className = 'zka';
    box.innerHTML = html();
    document.body.appendChild(box);
    session('zk_auth_shown', 1);
    lastFocus = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (box) box.classList.add('on'); }); });

    box.addEventListener('click', function (e) {
      if (e.target === box) { close(true); return; }
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-zka-close]')) { close(true); return; }
      if (t.closest('[data-zka-go]')) { store('zk_auth_until', Date.now() + DONE); }
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key !== 'Escape') return;
      document.removeEventListener('keydown', esc);
      close(true);
    });
    var img = box.querySelector('.zka-hd img');
    if (img) img.addEventListener('error', function () {
      var w = document.createElement('span'); w.className = 'zka-wm'; w.textContent = 'ZAKDOR';
      if (img.parentNode) img.parentNode.replaceChild(w, img);
    }, { once: true });
    var first = box.querySelector('[data-zka-go]');
    if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 400);
  }

  /* The order popup, a drawer or a hidden tab all mean "not now". Ask
     again a little later rather than interrupting. */
  function clearToShow() {
    if (document.hidden) return false;
    var busy = document.querySelector('.zkb-ov.on,.zkb-sheet.on,.zkb-cel,dialog[open],.cart-drawer[open],[aria-modal="true"]:not(.zka-c)');
    if (busy) return false;
    if (window.innerWidth < 520 && document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return false;
    return true;
  }

  var delay = MIN + Math.floor(Math.random() * (MAX - MIN));
  var started = Date.now();
  function tick() {
    if (Date.now() - started < delay) { setTimeout(tick, 1000); return; }
    if (!clearToShow()) { setTimeout(tick, 4000); return; }
    open();
  }
  setTimeout(tick, delay);
})();
